import React from 'react';
import { benefits } from '../Data/Data';
import './Benefits.css';

const Benefits = () => (
    <section className="section benefits" id="benefits">
        <div className="container benefits-grid">
            <h2>{benefits.title}</h2>
            <ul className="benefit-list">
                {benefits.blocks.map((b) => (
                    <li key={b.title}>
                        <h3>{b.title}</h3>
                        <p>{b.text}</p>
                    </li>
                ))}
            </ul>
        </div>
    </section>
);

export default Benefits;
